import React from 'react';
import { Select, Space, Tag, Typography } from 'antd';
import type { Quotation } from '@/services/quotation.service';
import { displayQuotationRevisionLabel } from '@/utils/quotationRevisionPolicy';
import { resolveFamilyRole } from '@/utils/quotationRevisionIntelligence';
import dayjs from 'dayjs';

const { Text } = Typography;

const ROLE_LABEL: Record<string, string> = {
  current_offer: 'CURRENT',
  accepted: 'CUSTOMER ACCEPTED',
  superseded: 'SUPERSEDED',
  draft_tip: 'DRAFT TIP',
  historical: 'HISTORICAL',
};

type Props = {
  quotation: Quotation;
  family: Quotation[];
  onSelect: (id: string) => void;
  loading?: boolean;
};

export const QuotationRevisionSelector: React.FC<Props> = ({
  quotation,
  family,
  onSelect,
  loading,
}) => {
  if (family.length <= 1 && Number(quotation.revision_number) <= 1) return null;

  const options = family.map((r) => {
    const role = resolveFamilyRole(r);
    const sent = r.sent_date ? dayjs(r.sent_date).format('DD MMM') : '';
    return {
      value: r.id,
      label: `${displayQuotationRevisionLabel(r.revision_number)}  ${r.status}${sent ? `  ${sent}` : ''}${role === 'current_offer' ? '  CURRENT' : ''}`,
    };
  });

  const role = resolveFamilyRole(quotation);
  const roleLabel = ROLE_LABEL[role] || role.toUpperCase();

  return (
    <Space wrap align="center">
      <Text type="secondary">Revision</Text>
      <Select
        style={{ minWidth: 200 }}
        value={quotation.id}
        options={options}
        loading={loading}
        onChange={onSelect}
        aria-label="Select quotation revision"
      />
      <Tag color={role === 'current_offer' || role === 'accepted' ? 'blue' : role === 'superseded' ? 'default' : 'gold'}>
        {roleLabel}
      </Tag>
    </Space>
  );
};

export default QuotationRevisionSelector;
